module.exports = __webpack_public_path__ + "static/media/argosBackground.18b2bdd2.png";